// 개발 중 /auth/* 엔드포인트를 가짜로 흉내내는 모듈

export const MOCK_USERS = {
  admin: {
    id: "01099990000", // user id = phone (digits only)
    phone: "010-9999-0000",
    name: "관리자",
    role: "admin",
    email: "admin@cardiofactory.kr",
    createdAt: "2025-09-30T00:00:00.000Z",
  },
  member: {
    id: "01012345678",
    phone: "010-1234-5678",
    name: "홍길동",
    role: "member",
    email: "hong@cardiofactory.kr",
    createdAt: "2025-09-30T00:00:00.000Z",
  },
};

// 모의 "세션" (메모리)
let current = null;

export function mockSignin(body = {}) {
  const phone = (body.phone || "").replace(/\D/g, "");
  if (phone === MOCK_USERS.admin.id) current = { ...MOCK_USERS.admin };
  else if (phone === MOCK_USERS.member.id) current = { ...MOCK_USERS.member };
  else current = { ...MOCK_USERS.member }; // 기본: 일반 회원
  return { ok: true };
}

export function mockMe() {
  if (!current) {
    const e = new Error("UNAUTHORIZED");
    e.status = 401;
    throw e;
  }
  return { ...current };
}

export function mockLogout() {
  current = null;
  return { ok: true };
}
